const PENDING_RELEASE_LOGIN_KEY = "pf_release_login";

/**
 * A practice release between its two steps (PF-6133): the code was accepted in this practice, the birthday is not yet
 * confirmed. Tab-scoped like the SMS login, and never in a URL, router state or a Sentry event.
 */
export type PendingReleaseLogin = { practiceId: string; code: string };

/** Carries the step when sessionStorage is blocked. */
let pendingInMemory: PendingReleaseLogin | undefined;

export const readPendingReleaseLogin = (): PendingReleaseLogin | undefined => {
  try {
    const raw = sessionStorage.getItem(PENDING_RELEASE_LOGIN_KEY);
    if (raw) return JSON.parse(raw) as PendingReleaseLogin;
  } catch {
    // the memory copy below
  }
  return pendingInMemory;
};

export const writePendingReleaseLogin = (pending: PendingReleaseLogin) => {
  pendingInMemory = pending;
  try {
    sessionStorage.setItem(PENDING_RELEASE_LOGIN_KEY, JSON.stringify(pending));
  } catch {
    // Storage blocked: the memory copy carries the step until the tab reloads.
  }
};

export const clearPendingReleaseLogin = () => {
  pendingInMemory = undefined;
  try {
    sessionStorage.removeItem(PENDING_RELEASE_LOGIN_KEY);
  } catch {
    // nothing to clear
  }
};

/** The code or the birthday step of a practice release, or a staff-fill hand-off, is open in this tab. */
export const hasPendingReleaseLogin = () =>
  readPendingReleaseLogin() !== undefined ||
  window.location.pathname.startsWith("/release/code") ||
  window.location.pathname.startsWith("/release/staff");
